<template>
  <div class="p-6 bg-white shadow-md rounded-lg px-4 py-2 card-body w-full">
    <div class="d-flex justify-content-between mb-4">
      <h3 class="text-2xl font-bold text-gray-800 mb-6 flex">Reporte Global de Evaluaciones</h3>
      <div class="d-flex flex-column justify-content-end">
        <button class="btn btn-default" @click="sendEmails" v-if="isManager">Enviar recordatorio de evaluaciones</button>
        <small class="text-gray-600" v-if="lastSend">Última notificación: {{ lastSend.sending_date }}</small>
      </div>
    </div>
    
    
    <div v-if="loading" class="text-gray-600">Cargando datos...</div>
    <div v-else-if="error" class="text-red-500 font-semibold">{{ error }}</div>
    <div v-else>
      <div class="tabs">
        <button 
          :class="{ active: activeTab === 'reporte' }"
          @click="activeTab = 'reporte'">
          Reporte Global
        </button>
        <button 
          v-if="isManager"
          :class="{ active: activeTab === 'pendientes' }"
          @click="activeTab = 'pendientes'">
          Evaluaciones Pendientes
        </button>
      </div>
      
      <div v-if="activeTab === 'reporte'">
        <div v-for="(area, index) in reportData" :key="index" class="mb-8">
          <p class="text-md font-semibold text-blue-600 border-b pb-2 mb-1 mt-2">
            Especialidad: {{ area.specialty || 'No Definida' }}
          </p>
          <div class="overflow-x-auto">
            <table class="w-full bg-white border border-gray-300 rounded-lg shadow-md mb-5">
              <thead class="bg-gray-100 text-gray-700 uppercase text-sm">
                <tr>
                  <th class="border px-4 py-3 text-left">Competencia</th>
                  <th class="border px-4 py-3 text-center">Autoevaluación</th>
                  <th class="border px-4 py-3 text-center">Evaluaciones de supervisión</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(comp, i) in mergeCompetencies(area)" :key="i" class="border hover:bg-gray-50">
                  <td class="border px-4 py-3">{{ comp.competency_name }}</td>
                  <td class="border px-4 py-3 text-center">{{ formatScore(comp.autoevaluation) }} Pts</td>
                  <td class="border px-4 py-3 text-center">{{ formatScore(comp.manager) }} Pts</td>
                </tr>
                <tr class="font-semibold text-gray-800 bg-gray-50">
                  <td class="border px-4 py-3">Promedio General</td>
                  <td class="border px-4 py-3 text-center">{{ formatScore(area.summary_for_graph.average_autoevaluation_score) }} Pts</td>
                  <td class="border px-4 py-3 text-center">{{ formatScore(area.summary_for_graph.average_manager_score) }} Pts</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <div v-if="activeTab === 'pendientes'">
          <div class="user-list">
            <div v-for="(specialty, index) in pendingUsers" :key="`spcl-${index}`" class="user-card mb-4">
              <div>
                <strong>{{ index }}</strong>
                  <table class="evaluation-table">
                    <thead>
                      <tr>
                        <th class="border px-4 py-3 text-center">Usuario</th>
                        <th class="border px-4 py-3 text-center">Autoevaluación</th>
                        <th class="border px-4 py-3 text-center">Evaluación de Jefe</th>
                        <th class="border px-4 py-3 text-center">Evaluaciones Asignadas</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in specialty.users" :key="user.id">
                        <td class="td-baseline border px-4 py-3 text-cente">
                          <span class="status-pending ">{{ user.name }}</span>
                        </td>
                        <td class="td-baseline border px-4 py-3 text-cente">
                          <span class="status-pending ">{{ user.autoevaluation ? 'Completado' : 'Pendiente' }}</span>
                        </td>
                        <td class="td-baseline border px-4 py-3 text-cente">
                          <span class="status-pending ">{{ user.evaluation_boss ? 'Completado' : 'Pendiente' }}</span>
                        </td>
                        <td class="td-baseline border px-4 py-3 text-cente">
                          <span class="status-pending ">{{ user.assigned_evaluation ? 'Completado' : 'Pendiente' }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/services/request";
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      reportData: [],
      pendingUsers: [],
      loading: true,
      error: null,
      isManager: false,
      lastSend: null,
      activeTab: 'reporte'
    };
  },
  mounted() {
    this.fetchReportData();
  },
  methods: {
    sendEmails() {
      try {
        request.post("/evaluations/remember-evaluations");
        this.successNotification("Recordatorio de evaluaciones enviados exitosamente.");
      } catch (err) {
        this.errorNotification("Error al enviar emails. Por favor, inténtelo de nuevo.");
      } finally {
        this.loading = false;
      }
    },
    async fetchReportData() {
      try {
        const { data } = await request.list("/evaluations/summary");
        this.reportData = data.data;
        this.isManager = data.is_manager;
        this.lastSend = data.last_send;
        this.pendingUsers = data.pending_evaluations;
      } catch (err) {
        console.error("Error al cargar los datos:", err);
        this.error = "No se pudo cargar el reporte. Inténtelo más tarde.";
      } finally {
        this.loading = false;
      }
    },
    mergeCompetencies(area) {
      const auto = area.average_autoevaluation_scores || [];
      const managers = area.average_manager_scores || [];
      const merged = new Map();
      auto.forEach(c => merged.set(c.competency_name, { competency_name: c.competency_name, autoevaluation: c.average_score, manager: null }));
      managers.forEach(c => {
        if (merged.has(c.competency_name)) {
          merged.get(c.competency_name).manager = c.average_score;
        } else {
          merged.set(c.competency_name, { competency_name: c.competency_name, autoevaluation: null, manager: c.average_score });
        }
      });
      return Array.from(merged.values());
    },
    formatScore(score) {
      return score !== null ? score.toFixed(2) : "N/A";
    },
     ...mapActions({
      successNotification: 'alert/success',
      errorNotification: 'alert/error',
    }),
  },
};
</script>

<style scoped>
th {
  background-color: #f3f4f6;
  font-weight: bold;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.tabs {
  display: flex;
  margin-bottom: 15px;
}
.tabs button {
  flex: 1;
  padding: 10px;
  cursor: pointer;
  border: none;
  background: #f1f1f1;
}
.tabs button.active {
  background: #1d4745;
  color: white;
}
.hidden {
  display: none;
}
.evaluation-table{
  width: 100%;
}
</style>
